// extracted by mini-css-extract-plugin
module.exports = {"root":"_1zly8"};